import { makeSvgIcon } from '../makeSvgIcon'

export const arc = makeSvgIcon(
  <path d="M12 4C6.47715 4 2 8.47715 2 14V20H9V14C9 12.3431 10.3431 11 12 11C13.6569 11 15 12.3431 15 14V20H22V14C22 8.47715 17.5228 4 12 4Z" />
)
